import React from "react";
//#region types
import { SelfInvoiceCreateViewProps } from "models/propTypes/selfInvoicePropTypes";
import { TranslationKeys } from "translations";
import { HTMLConstants } from "utils/constants";
//#endregion
//#region components
import { PageLayouts, ViewPanel, SimpleEntityTitle, Skeletons } from "components/common";
import CreateSelfInvoiceContainer from "./forms/createFormContainer";
import { Grid } from "@mui/material";
import SelfInvoiceFileViewer from "./fileViewer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const CreateSelfInvoice: React.FC<SelfInvoiceCreateViewProps> = ({
  loading,
  invoice,
  draftCustomerInvoice,
  reloadInvoice,
}) => {
  const upperLeftComponent = React.useMemo(
    () => (
      <SimpleEntityTitle
        title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.EditSelfInvoice)}
        status={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Draft)}
      />
    ),
    [invoice]
  );

  const upperRightComponent = React.useMemo(
    () =>
      loading ? (
        <></>
      ) : (
        <Grid item container justifyContent="space-between" direction="row" alignItems="center">
          <Grid item id={HTMLConstants.WizardQuickSelectionPortalId}></Grid>
        </Grid>
      ),
    [loading, invoice?.id]
  );

  return (
    <PageLayouts.EntityCreationLayout
      className={cssExports.invoiceCreationWizard}
      upperLeftComponent={upperLeftComponent}
      upperRightComponent={upperRightComponent}
      lowerLeftComponent={<SelfInvoiceFileViewer invoice={invoice} />}
    >
      {loading ? (
        <ViewPanel>
          <Skeletons.FormSkeleton />
        </ViewPanel>
      ) : invoice ? (
        <ViewPanel className={cssExports.wizardOuter}>
          <CreateSelfInvoiceContainer
            invoice={invoice}
            draftCustomerInvoice={draftCustomerInvoice}
            reloadInvoice={reloadInvoice}
          />
        </ViewPanel>
      ) : (
        <></>
      )}
    </PageLayouts.EntityCreationLayout>
  );
};

export default CreateSelfInvoice;
